import { render } from "./NotSupportComponent.vue?vue&type=template&id=3191aa04&scoped=true"
const script = {}

import "./NotSupportComponent.vue?vue&type=style&index=0&id=3191aa04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3191aa04"]])

export default __exports__